export default class OnsiteThankyouPage2024Q4 {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    // this.createLoading();
    this.initTouchStart();

    const btnDownload = this.dom.querySelector("#btn-download");
    btnDownload.addEventListener("click", () => {
      this.handleDownload();
    });
  }

  initTouchStart() {
    window.addEventListener(
      "touchstart",
      () => {
        document.body.classList.add("is-touch");
      },
      { once: true }
    );
  }

  createLoading() {
    this.loadingDOM = document.createElement("div");
    this.loadingDOM.id = "onsite-loading";

    const loadingWrapperDOM = document.createElement("div");
    loadingWrapperDOM.className = "loading-wrapper";
    this.loadingDOM.append(loadingWrapperDOM);

    const loaderDOM = document.createElement("div");
    loaderDOM.className = "loader";
    loadingWrapperDOM.append(loaderDOM);

    this.dom.append(this.loadingDOM);
  }

  updatePrintRefNumber(refNum) {
    let label = this.dom.querySelector("#print-reference span");
    label.textContent = refNum;
  }

  async handleDownload() {
    const btnDownload = this.dom.querySelector("#btn-download");
    this.mediaUrl = btnDownload.getAttribute("data-media");

    if (navigator.canShare && document.body.classList.contains("is-touch")) {
      this.blob = await fetch(this.mediaUrl).then((result) => result.blob());
      console.log(this.blob);

      let fileName = "";
      if (this.blob.type == "image/jpeg" || this.blob.type == "image/jpg") {
        fileName = "metalook.jpg";
      } else if (this.blob.type == "video/mp4") {
        fileName = "metalook.mp4";
      }

      navigator
        .share({
          files: [new File([this.blob], fileName, { type: this.blob.type })],
        })
        .then(() => console.log("Share was successful."))
        .catch((error) => {
          console.log("Sharing failed", error);
          if (error.name == "NotAllowedError") {
            this.simpleDownload();
          }
        });
    } else {
      this.simpleDownload();
    }
  }

  simpleDownload() {
    let media = this.mediaUrl;
    let link = document.createElement("a");
    link.href = media;

    let ext = "";
    if (this.mediaUrl.includes(".jpg")) {
      ext = ".jpg";
    } else if (this.mediaUrl.includes(".mp4")) {
      ext = ".mp4";
    }

    link.download = `metalook${ext}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  resize() {}
}
